import { FC } from 'react'
import BlueIndicatorSVG from '../../assets/svg/tankInfo/indicator-blue.svg?react'
import RedIndicatorSVG from '../../assets/svg/tankInfo/indicator-red.svg?react'
import './MeasureGauge.css'
import { BarSVG } from './svg/BarSVG'

export type MeasureGaugeProps = {
  minLimit: number
  maxLimit: number
  minWarning: number
  maxWarning: number
  value: number | undefined | null
}

export const MeasureGauge: FC<MeasureGaugeProps> = ({
  minLimit,
  maxLimit,
  minWarning,
  maxWarning,
  value,
}) => {
  const indicator =
    value === undefined || value === null ? (
      <></>
    ) : minWarning < value && maxWarning > value ? (
      <BlueIndicatorSVG width="28px" height="28px" />
    ) : (
      <RedIndicatorSVG width="28px" height="28px" />
    )
  const position =
    value === undefined || value === null
      ? 0
      : value >= maxLimit
        ? 100
        : value <= minLimit
          ? 0
          : ((value - minLimit) / (maxLimit - minLimit)) * 100
  // const position = 0

  const minWarningPortion = (minWarning - minLimit) / (maxLimit - minLimit)
  const maxWarningPortion = (maxWarning - minLimit) / (maxLimit - minLimit)
  const greyStart = minWarningPortion * 100
  const greyEnd = maxWarningPortion * 100
  const redEnd = 100 - greyEnd

  // Calculate indicator position
  const indicatorPosition = `${position - 14}px`

  // Calculate warning label positions based on their percentage on the gauge
  const minWarningPosition = minWarningPortion * 100 - 8 // Adjust for label width
  const maxWarningPosition = maxWarningPortion * 100 + 2 // Move 4px to the right of grey zone end

  return (
    <div className="measure-gauge-container">
      <div className="measure-gauge-warning-row">
        <span
          className="measure-gauge-warning-min"
          style={{ left: `${Math.max(0, minWarningPosition)}px` }}
        >
          {minWarning}
        </span>
        <span
          className="measure-gauge-warning-max"
          style={{ left: `${Math.min(90, maxWarningPosition)}px` }}
        >
          {maxWarning}
        </span>
      </div>
      <div className="measure-gauge-bar-container">
        <div className="measure-gauge-bar-wrapper">
          <div className="measure-gauge-bar">
            <BarSVG greyStart={greyStart} greyEnd={greyEnd} redEnd={redEnd} />
          </div>
          {value === null || value === undefined ? null : (
            <div className="measure-gauge-indicator" style={{ left: indicatorPosition }}>
              {indicator}
            </div>
          )}
        </div>
      </div>
      <div className="measure-gauge-limit-row">
        <span className="measure-gauge-limit-min">{minLimit}</span>
        <span className="measure-gauge-limit-max">{maxLimit}</span>
      </div>
    </div>
  )
}

export default MeasureGauge
